var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88443 0.579176C4.74631 0.528952 4.59309 0.542036 4.46549 0.614952L0.105882 3.10615C0.0404071 3.14357 0 3.2132 0 3.28861C0 3.37698 0.0552864 3.4559 0.138337 3.4861L7.02121 5.98853C7.15931 6.03874 7.3125 6.02566 7.44008 5.95278L11.9287 3.38846C11.9728 3.36328 12 3.31643 12 3.26569C12 3.20624 11.9628 3.15313 11.9069 3.13281L4.88443 0.579176ZM12 6.4217C12 6.07853 11.6293 5.86339 11.3313 6.03364L7.82975 8.03449C7.57465 8.18026 7.26801 8.20706 6.99186 8.10675L0.670887 5.80799C0.344793 5.6894 0 5.93089 0 6.27788V6.41892C0 6.62918 0.131546 6.81698 0.329154 6.88882L7.02121 9.32188C7.15931 9.37209 7.3125 9.35901 7.44008 9.28612L11.7748 6.80977C11.914 6.7302 12 6.5821 12 6.4217ZM0.329128 10.6197C0.131534 10.5478 0 10.36 0 10.1498V9.61123C0 9.26424 0.344793 9.02274 0.670887 9.14134L6.99186 11.4401C7.26801 11.5404 7.57465 11.5136 7.82975 11.3678L11.2519 9.41235C11.5853 9.22189 12 9.46257 12 9.84648V10.2098C12 10.3893 11.9039 10.5549 11.7481 10.644L7.53451 13.0517C7.40691 13.1246 7.25369 13.1377 7.11557 13.0875L0.329128 10.6197Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuffer);
export default __webpack_public_path__ + "static/media/buffer.69e0b00561847f98c103f41796670e3c.svg";
export { ForwardRef as ReactComponent };